import React from "react";
import { Check } from "lucide-react";
import { Chip } from "../Sticker";
import { ROLE_COLORS } from "../../lib/dance";
import { studentTypeLabel } from "../../lib/classDashboard";

export default function AttendanceStudentRow({
  rsvp,
  checkInTime,
  busy,
  onMarkPresent,
}) {
  const attended = rsvp.status === "ATTENDED";
  const role = rsvp.role || null;
  const typeLabel = studentTypeLabel(rsvp);

  return (
    <li
      className="py-3 first:pt-0 border-b border-black/[0.08] last:border-b-0"
      data-testid={`class-dash-student-${rsvp.id}`}
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 flex-1">
          <div className="font-ui font-semibold text-[15px] text-ink truncate">
            {rsvp.name || "Student"}
          </div>
          <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
            {role ? (
              <Chip color={ROLE_COLORS[role] || "cream"} className="text-[12px]">
                {role}
              </Chip>
            ) : null}
            <span className="font-ui text-[12px] font-medium text-ink/60 px-2 py-0.5 rounded-btn bg-black/[0.04]">
              {typeLabel}
            </span>
          </div>
        </div>

        {attended ? (
          <div
            className="inline-flex items-center justify-center gap-2 min-h-[48px] px-4 rounded-btn bg-leaders/60 text-plum border border-plum/25 font-ui text-[14px] font-semibold shrink-0"
            data-testid={`class-dash-checked-in-${rsvp.id}`}
          >
            <Check className="w-4 h-4" strokeWidth={2.5} aria-hidden />
            Checked In
            {checkInTime ? (
              <span className="font-medium text-plum/70">{checkInTime}</span>
            ) : null}
          </div>
        ) : (
          <button
            type="button"
            disabled={busy}
            onClick={onMarkPresent}
            className="inline-flex items-center justify-center min-h-[48px] px-4 rounded-btn border-2 border-black/15 bg-white font-ui text-[14px] font-semibold text-ink hover:border-plum/40 hover:bg-cream/50 disabled:opacity-50 shrink-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
            data-testid={`class-dash-mark-present-${rsvp.id}`}
          >
            {busy ? "Saving…" : "Mark Present"}
          </button>
        )}
      </div>
    </li>
  );
}
